import store from '../../store';
import Vue from 'vue';
import UserProfileStepper from '@/widgets/user-profile-stepper';

/**
 * This will return true if the profile is completely setup, otherwise it will
 * return false and prompt the user to complete their profile.
 *
 * @returns {boolean}
 */
export function profileCompleteGuard(componentContext) {
  // Profile stepper can not be entered if the user has completed their profile
  // or they are not able to edit their profile
  if (
    store.getters['user/isProfileSetupComplete'] ||
    !store.getters['user/canEditProfile']
  ) {
    return true;
  }

  Vue.prototype.SAIDialog({
    header: 'Profile Incomplete',
    body: 'You must complete your profile so we can verify your details before you can create a quote.',
    okText: 'Complete Profile',
    onOk: () => {
      Vue.prototype.SAIFullScreenDialog({
        parent: componentContext,
        noRouteDismiss: true,
        displayHideAction: false,
        child: UserProfileStepper
      });
    }
  });

  return false;
}
